export default __webpack_public_path__ + "static/media/mockup-laptop.42fd8fdc.png";